<!--隐私协议-->
<template>
    <div class="reload-view">
        <div class="top-back">
            <div class="code">{{sum_children_revenue}} <span style="font-size: 20px">￥</span></div>
            <div class="top-text">下层邀请累计收益 </div>
        </div>

        <div class="main">
            <div class="main-option">
                下层收益明细
            </div>
            <div class="main-list" :style="marSty">
                <van-list
                    v-model:loading="loading"
                    :finished="finished"
                    :finished-text="loadingText"
                    @load="onLoad"
                >
                    <div class="main-list-info" v-for="item in list" :key="item.withdraw_id" :title="item" @click="goTotals(item.withdraw_id)">
                        <div class="main-list-info-name">
                            {{item.nickname}}
                        </div>

                        <div class="main-list-info-text">
                            <span style="color: #F94B54">{{item.revenue}}元</span>
                        </div>

                        <div class="main-list-info-time">
                            累计邀请 {{ item.sum_bind_count }} 人
                        </div>
                    </div>
                </van-list>

            </div>

        </div>
        <ReferralFooter index="2"/>

    </div>

</template>

<script>

import {showFailToast} from "vant";
import ReferralFooter  from "@/components/referralFooter.vue";
import ayzAjax from "@/plugins/axios";

export default {
    name: "ReloadView",
    components: {
        ReferralFooter
    },
    data: function () {
        return {
            sum_children_revenue:0.00,
            list:[],
            loading:false,
            finished:false,
            page:1,
            jwtInfo:null,
            userInfo:null,
            loadingText: '暂无数据',
            marSty:{}
        }
    },
    created() {
        this.jwtInfo = JSON.parse(localStorage.getItem('jwtInfo'));
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
    },
    methods: {
        onLoad(){
            let url = '/referral/children_revenues?page=' + this.page;

            try {
                ayzAjax.get(url,{
                    headers: {
                        'Authorization': 'Bearer ' + this.jwtInfo.access_token,
                    }
                }).then((info) => {
                    if (info.data.code === 4){
                        return this.$router.push({ path: '/referral/login'});
                    }
                    // console.log(info.data.data)
                    if(info.data.code !== 200){
                        this.$router.push({ path: '/referral/index'});
                        return showFailToast(info.data.msg);
                    }
                    this.sum_children_revenue = info.data.data.sum_children_revenue;
                    
                    info.data.data.revenues.forEach((item) => {
                        this.list.push(item);
                    });
                    this.loading = false;
                    if (info.data.data.revenues.length < 20) {
                        this.finished = true;
                    }else{
                        this.finished = false;
                        this.page ++;
                    }
                    if (this.list.length > 0) {
                        this.loadingText = '到底了';
                    }else{
                      this.marSty = {marginTop: '100px'}
                    }
                })
            }catch(err) {
                console.log(err);
                showFailToast('网络错误,请稍后再试');
            }
        },
        goTotals(id){
            this.$router.push({ path: '/referral/totals', query: { id:id} });
        }
    }
}
</script>

<style lang="scss" scoped>

.reload-view {
    background-color: #F6F6F6;
    text-align: left;
    .top-back {
        background-image: url('~@/assets/referral-back2.png');
        background-size: cover;
        background-repeat: no-repeat;
        width: 100%;
        height: 120px;
        color: #FFFFFF;
        .code {
            padding-top: 30px;
            padding-left: 30px;
            font-weight: 600;
            font-size: 27px;
        }
        .top-text {
            margin-top: 15px;
            margin-left: 30px;
            margin-right: 25px;
            font-weight: 300;
            font-size: 14px;
        }
    }
    .main {
        min-height: 500px;
        margin: 12px;
        background: #FFFFFF;
        border-radius: 17px 17px 17px 17px;
        .main-option{
            padding-top: 25px;
            margin-left: 15px;
            font-weight: 500;
            font-size: 15px;
            color: #222222;
            margin-bottom: 15px;
        }
        .main-list-info{
            margin-top: 5px;
            height: 40px;
            //background: #F94B54;
            line-height: 40px;
            padding-left: 15px;
            font-size: 12px;
            .main-list-info-name{
                float: left;
                width: 110px;
                color: #555555;
                //font-weight: bold;
            }

            .main-list-info-text{
                width: 115px;
                float: left;
                color: #555555;
            }
            .main-list-info-time{
                float: left;
                color: #555555;
            }
        }
    }
}
</style>
